import * as React from 'react';

import { Wrapper } from './styles';
import Header from './Header';
import Content from './Content';

interface ContentStructureToastProps {
	isDisplayed: boolean;
	isPreparingContentStructure: boolean;
	contentStructureReady: boolean;
	needsContentStructureCompletion?: boolean;
	contentStructureEverCompleted?: boolean;
	isReturnVisitOfflineInit?: boolean;
	isDownloadingRequiredItems?: boolean;
	isDownloadingThumbs?: boolean;
	isDownloadManagerActive?: boolean;
	screenWidth?: number;
	onRetryContentStructure?: () => void;
	onClose?: () => void;
}

const ContentStructureToast = ({
	isDisplayed,
	isPreparingContentStructure,
	contentStructureReady,
	needsContentStructureCompletion,
	contentStructureEverCompleted,
	isReturnVisitOfflineInit = false,
	isDownloadingRequiredItems = false,
	isDownloadingThumbs = false,
	isDownloadManagerActive = false,
	screenWidth = typeof window !== 'undefined' ? (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) : 0,
	onRetryContentStructure,
	onClose,
}: ContentStructureToastProps) => {
	// Initialize expanded state - always start expanded when content structure completion is needed
	const [isExpanded, setIsExpanded] = React.useState(true);
	const [currentScreenWidth, setCurrentScreenWidth] = React.useState(screenWidth);

	// Update screen width on resize
	React.useEffect(() => {
		const handleResize = () => {
			setCurrentScreenWidth(window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	// Ensure widget stays expanded when content structure completion is needed
	React.useEffect(() => {
		if (needsContentStructureCompletion) {
			setIsExpanded(true);
		}
	}, [needsContentStructureCompletion]);

	return (
		<Wrapper isDisplayed={isDisplayed} isDownloadManagerActive={isDownloadManagerActive} screenWidth={currentScreenWidth}>
			<Header
				isToastExpanded={isExpanded}
				onToggle={() => setIsExpanded(!isExpanded)}
				onClose={onClose || (() => {
					// No-op: close handler is optional
				})}
				isPreparingContentStructure={isPreparingContentStructure}
				contentStructureReady={contentStructureReady}
				needsContentStructureCompletion={needsContentStructureCompletion}
				contentStructureEverCompleted={contentStructureEverCompleted}
				isReturnVisitOfflineInit={isReturnVisitOfflineInit}
				isDownloadingRequiredItems={isDownloadingRequiredItems}
				isDownloadingThumbs={isDownloadingThumbs}
			/>
			{isExpanded &&
				<Content
					isPreparingContentStructure={isPreparingContentStructure}
					contentStructureReady={contentStructureReady}
					needsContentStructureCompletion={needsContentStructureCompletion}
					onRetryContentStructure={onRetryContentStructure}
					contentStructureEverCompleted={contentStructureEverCompleted}
					isReturnVisitOfflineInit={isReturnVisitOfflineInit}
					isDownloadingRequiredItems={isDownloadingRequiredItems}
					isDownloadingThumbs={isDownloadingThumbs}
				/>
			}
		</Wrapper>
	);
};

export default ContentStructureToast;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ContentStructureToast/index.tsx